import { Grid } from '@material-ui/core'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import DispensaryPromoRow from './DispensaryPromoRow'
import { StyledColumnHeader, StyledColumnHeaderLink } from './styled'
import { CustomerDispensaryPromo, CustomerDispensaryPromos, MutatePromoProps } from './types'

const StyledEmptyMessage = styled.div`
  margin-top: 8px;
  line-height: 30px;
  text-align: center;
`

export interface DispensaryPromoTableProps {
  promos: CustomerDispensaryPromos
  mutatePromoProps: MutatePromoProps
}

const DispensaryPromoTable: React.FC<DispensaryPromoTableProps> = ({
  promos,
  mutatePromoProps,
}) => {
  const [activePromos, inactivePromos] = useMemo(
    (): [CustomerDispensaryPromo[], CustomerDispensaryPromo[]] => [
      promos.filter((promo): promo is CustomerDispensaryPromo => !!promo && !promo.inactive),
      promos.filter((promo): promo is CustomerDispensaryPromo => !!promo && promo.inactive),
    ],
    [promos],
  )
  const [showInactivePromos, setShowInactivePromos] = useState(false)
  const toggleInactivePromos = () => {
    setShowInactivePromos(!showInactivePromos)
  }
  return (
    <Grid container spacing={5}>
      <Grid item xs={1}></Grid>
      <Grid item xs={5}>
        <StyledColumnHeader>Code</StyledColumnHeader>
      </Grid>
      <Grid item xs={2}>
        <StyledColumnHeader>Promotion</StyledColumnHeader>
      </Grid>
      <Grid item xs={4}>
        <StyledColumnHeaderLink onClick={toggleInactivePromos}>
          {showInactivePromos ? 'Hide' : 'Show'} inactive promos
        </StyledColumnHeaderLink>
      </Grid>
      {activePromos.map((promo) => (
        <DispensaryPromoRow key={promo.id} promo={promo} mutatePromoProps={mutatePromoProps} />
      ))}
      {showInactivePromos &&
        inactivePromos.map((promo) => (
          <DispensaryPromoRow key={promo.id} promo={promo} mutatePromoProps={mutatePromoProps} />
        ))}
      {!showInactivePromos && activePromos.length === 0 && inactivePromos.length > 0 && (
        <Grid item xs={12}>
          <StyledEmptyMessage>No active promotions.</StyledEmptyMessage>
        </Grid>
      )}
    </Grid>
  )
}

export default DispensaryPromoTable
